import { createSlice } from '@reduxjs/toolkit';
import {
  getBudgetData,
  postCreateGLCode,
  postDeleteBudget,
  postCopyBudget,
  postBudgetForm,
  postDeleteGLCodes,
} from '../../api/budgets';

const initialState = {
  isLoading: false,
  error: null,
  data: {
    agoraCategories: [],
    agoraSubcategories: [],
    budgets: [],
    facilities: [],
    glCodes: [],
  },
};

const slice = createSlice({
  name: 'budget',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    getBudgetSuccess: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },

    deleteBudgetSuccess(state, action) {
      state.isLoading = false;
      state.data.budgets = state.data.budgets.filter((item) => !action.payload.includes(item.id));
    },
    updateBudgetSuccess(state, action) {
      state.isLoading = false;
      const updatedBudget = action.payload.budget;
      state.data.budgets = state.data.budgets.map((item) => (item.id === updatedBudget.id ? updatedBudget : item));
    },
    insertBudgetSuccess(state, action) {
      state.isLoading = false;
      const newBudget = action.payload.budget;
      state.data.budgets = [...state.data.budgets, newBudget];
    },
    copyBudgetSuccess(state, action) {
      state.isLoading = false;
      const { newBudget, facilityIds } = action.payload;
      state.data.budgets = [...state.data.budgets.filter(budget => !facilityIds?.includes(budget.facilityId)), ...newBudget];
    },
    insertGlCodeSuccess(state, action) {
      state.isLoading = false;
      const newGlCode = action.payload;
      state.data.glCodes = [...state.data.glCodes, newGlCode];
    },
  },
});

export default slice.reducer;

export function getBudget() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getBudgetData();
      dispatch(slice.actions.getBudgetSuccess(response.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
    return null;
  };
}

export function deleteBudgets(ids) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await postDeleteBudget(ids);
      if (response.status === 200) {
        dispatch(slice.actions.deleteBudgetSuccess(ids));
        return true;
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
    return null;
  };
}

export function removeBudgets(ids) {
  return async (dispatch) => {  
    dispatch(slice.actions.deleteBudgetSuccess(ids));    
  };
}

export function budgetForm(form, id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await postBudgetForm(form, id);
      if (response.status === 200) {
        const updatedBudget = response.data;
        if (response.data.message === "Success") {
          if (id > 0) dispatch(slice.actions.updateBudgetSuccess(updatedBudget));
          else dispatch(slice.actions.insertBudgetSuccess(updatedBudget));
        }
        return updatedBudget;
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
    return null;
  };
}
export function copyBudget(facilityIds, facilityCopyId, facilityCopyGLId, agoraCategoryIds) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await postCopyBudget(facilityIds, facilityCopyId, facilityCopyGLId, agoraCategoryIds);
      if (response.status === 200) {
        const newBudget = response.data;
        dispatch(slice.actions.copyBudgetSuccess({ newBudget, facilityIds: facilityIds.map(facility => facility.id) }));
        return response.data;
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
    return null;
  };
}
export function createGlCode(glCode, facilityBookingId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await postCreateGLCode(glCode, facilityBookingId);
      if (response.status === 200) {
        dispatch(
          slice.actions.insertGlCodeSuccess({
            id: response.data,
            label: glCode,
            facilityBookingTypeId: facilityBookingId,
          })
        );
      }
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return null;
    }
  };
}

export function deleteGlCodes(glCodes) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await postDeleteGLCodes(glCodes);
      return response.data;
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      return null;
    }
  };
}